import React from 'react'
import find from 'lodash/find'
import { connect } from 'react-redux'

import {
  addShippingAddress,
  selectShippingAddressAsync,
  deleteAddress,
  updateAddress,
  selectShippingAndBillingAddressAsync,
  useBillingForShippingToggle
} from './addressActionCreators'

import CheckoutAddressComponent from './CheckoutAddressComponent'

const mapShippingAddressStateToProps = (state) => {
  const e = state.entities;
  const c = state.constants;
  const useShippingForBilling = state.ui.useShippingForBilling;
  return {
    addresses: e.ShippingAddresses.map(
      id => find(e.Addresses, address => address.Id === id)),
    selectedAddressId: e.SelectedShippingAddressId,
    addressType: c.ShippingAddressType,
    addressActionCreators: {
      add: addShippingAddress,
      remove: deleteAddress,
      select: useShippingForBilling ? selectShippingAndBillingAddressAsync : selectShippingAddressAsync,
      update: updateAddress
    },
    selectAddressMessage: useShippingForBilling ? "Bill and Ship to this address" : "Ship to this address",
    useForAnotherMessage: "Use shipping for billing address",
    useForAnotherSelected: useShippingForBilling,
    sectionLabel: "Shipping Address",
    disableBillingChanges: state.ui.disableBillingChanges,
    localizationItems: state.constants.localizationItems
  }
}

const mapShippingAddressDispatchToProps = dispatch => {
  return {
    onUseForAnotherClicked: () => dispatch(useBillingForShippingToggle())
  }
}

const CheckoutShippingAddressContainer = connect(
  mapShippingAddressStateToProps,
  mapShippingAddressDispatchToProps
)(CheckoutAddressComponent);

export default CheckoutShippingAddressContainer;


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/Address/CheckoutShippingAddressContainer.js